import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-daohang",
  "use": "icon-daohang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-daohang\"><defs><style type=\"text/css\"></style></defs><path d=\"M27.896681 409.552564 442.07974 582.016938l172.367069 414.156301L996.103283 27.967853 27.896681 409.552564 27.896681 409.552564zM490.512025 528.899424 204.468537 409.855425l668.665712-263.511328L490.512025 528.899424 490.512025 528.899424zM490.512025 528.899424\" p-id=\"13413\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol